export default __webpack_public_path__ + "static/clientWork5-e79ca5825fd95a844f632e7dd76d0342.png";